/*
 * WhatsApp OTP login for beautifybysneha.in
 * ------------------------------------------
 * Identity provider: beautifybysneha.com (the NUTRA app). The two sites are
 * different domains, so they can't share a cookie. Instead:
 *
 *   store → .com   After an OTP login here, one hop through
 *                  <api>/sso/handoff plants the .com session cookie.
 *   .com  → store  Clicking "Log in" first bounces once through <api>/sso/go.
 *                  If the visitor is signed in on .com it returns with a
 *                  one-time code (#bbs_sso=…) that we swap for a store token —
 *                  no OTP needed. Otherwise it returns #bbs_sso=none and the
 *                  WhatsApp popup opens.
 *
 * The store token is a bearer JWT in localStorage; it can only read the
 * visitor's own orders and coupons.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('bbs-account-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var API = String(CFG.apiBase || '').replace(/\/+$/, '');
  var K_TOKEN = 'bbs_shop_token', K_USER = 'bbs_shop_user';
  var S_CHECKED = 'bbs_sso_checked', S_OPEN = 'bbs_open_after_sso', S_NEXT = 'bbs_after_login';

  // ── storage (private mode can throw) ────────────────────────────────────────
  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  function token() { return ls(K_TOKEN); }
  function user() { try { return JSON.parse(ls(K_USER) || 'null'); } catch (e) { return null; } }
  function saveLogin(t, u) { ls(K_TOKEN, t); ls(K_USER, JSON.stringify(u || {})); ss(S_CHECKED, '1'); }
  function clearLogin() { ls(K_TOKEN, null); ls(K_USER, null); }

  function accountUrl() {
    var u = new URL(CFG.accountUrl || '/pages/my-account', location.origin);
    var cur = new URL(location.href);
    if (cur.searchParams.has('preview_theme_id')) {
      u.searchParams.set('preview_theme_id', cur.searchParams.get('preview_theme_id'));
    }
    return u.toString();
  }
  function here() { var u = new URL(location.href); u.hash = ''; return u.toString(); }

  function request(path, opts) {
    opts = opts || {};
    var headers = { 'Accept': 'application/json' };
    if (opts.body) headers['Content-Type'] = 'application/json';
    if (opts.auth && token()) headers['Authorization'] = 'Bearer ' + token();
    return fetch(API + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
      credentials: 'omit',
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (res.status === 401 && opts.auth) { clearLogin(); paintHeader(); }
        if (!res.ok || data.ok === false) {
          var err = new Error(data.error || data.message || ('Something went wrong (' + res.status + ')'));
          err.status = res.status; err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  // ── header button ───────────────────────────────────────────────────────────
  function paintHeader() {
    var u = token() ? user() : null;
    document.querySelectorAll('[data-bbs-account]').forEach(function (btn) {
      btn.classList.toggle('is-in', !!u);
      btn.setAttribute('aria-label', u ? 'My account' : 'Log in');
      var hi = btn.querySelector('.bbs-account-btn__hi');
      if (hi) hi.textContent = u ? (u.name ? 'Hi, ' + String(u.name).split(' ')[0] : 'My account') : '';
    });
  }

  function goAccountOrLogin(next) {
    if (token()) { location.href = next || accountUrl(); return; }
    if (next) ss(S_NEXT, next);
    // One silent bounce per browser session to pick up a .com login.
    if (!ss(S_CHECKED)) {
      ss(S_OPEN, '1');
      location.href = API + '/sso/go?to=' + encodeURIComponent(here());
      return;
    }
    openModal();
  }

  // ── modal ───────────────────────────────────────────────────────────────────
  var modal = document.getElementById('bbs-login');
  var phoneDigits = '';
  var resendTimer = null;
  // Inline mode: the cart drawer opens the same modal but must not navigate
  // away afterwards, or the shopper loses their place in the cart.
  var inline = false;
  var inlineDone = null;

  function $(sel) { return modal.querySelector(sel); }
  function step(name) {
    modal.querySelectorAll('[data-step]').forEach(function (el) { el.hidden = el.getAttribute('data-step') !== name; });
    msg('');
    var f = $('[data-step="' + name + '"] input');
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function msg(text, ok) {
    var m = $('.bbs-login__msg');
    m.textContent = text || '';
    m.classList.toggle('is-ok', !!ok);
  }
  function busy(form, on) {
    var b = form.querySelector('.bbs-login__btn');
    if (b) { b.disabled = on; if (on) { b.dataset.label = b.textContent; b.textContent = 'Please wait…'; } else if (b.dataset.label) b.textContent = b.dataset.label; }
  }

  function openModal() {
    if (!modal) return;
    inline = false; inlineDone = null;
    modal.hidden = false;
    document.body.classList.add('bbs-login-open');
    step(phoneDigits ? 'code' : 'phone');
  }
  /** Log in without leaving the page. `done` runs once the token is stored. */
  function openModalInline(done) {
    if (!modal) return;
    if (token()) { if (done) done(user()); return; }
    inline = true; inlineDone = done || null;
    modal.hidden = false;
    document.body.classList.add('bbs-login-open');
    step(phoneDigits ? 'code' : 'phone');
  }
  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('bbs-login-open');
    inline = false; inlineDone = null;
  }

  function startResendCountdown(sec) {
    var btn = $('[data-bbs-resend]');
    clearInterval(resendTimer);
    var left = sec || 60;
    btn.disabled = true;
    btn.textContent = 'Resend in ' + left + 's';
    resendTimer = setInterval(function () {
      left -= 1;
      if (left <= 0) { clearInterval(resendTimer); btn.disabled = false; btn.textContent = 'Resend code'; }
      else btn.textContent = 'Resend in ' + left + 's';
    }, 1000);
  }

  function friendly(err) {
    if (err.status === 403) return 'WhatsApp login isn’t open for this number yet. Please try again soon.';
    if (err.status === 429) return err.message || 'Too many attempts. Please wait a bit and try again.';
    if (!err.status) return 'Can’t reach the login service. Check your connection and try again.';
    return err.message;
  }

  function sendCode(form) {
    busy(form, true);
    return request('/api/auth/request-code', { method: 'POST', body: { phone: phoneDigits, countryCode: '91' } })
      .then(function (r) {
        $('[data-bbs-phone]').textContent = '+91 ' + phoneDigits.replace(/(\d{5})(\d{5})/, '$1 $2');
        step('code');
        startResendCountdown(r.resendIn || 60);
        msg('Code sent on WhatsApp.', true);
      })
      .catch(function (e) { msg(friendly(e)); })
      .then(function () { busy(form, false); });
  }

  function afterLogin(res) {
    saveLogin(res.shopToken, res.user);
    paintHeader();
    step('done');
    if (inline) {
      // No handoff hop here: it is a top-level redirect, which would take the
      // shopper off the cart. The .com session is planted on the next normal
      // login from the account page.
      var cb = inlineDone;
      setTimeout(function () {
        closeModal();
        document.dispatchEvent(new CustomEvent('bbs:login', { detail: res.user || null }));
        if (cb) cb(res.user || null);
      }, 500);
      return;
    }
    var next = ss(S_NEXT) || (location.pathname === new URL(accountUrl()).pathname ? here() : accountUrl());
    ss(S_NEXT, null);
    // Plant the beautifybysneha.com session too, then come straight back.
    if (CFG.handoff && res.handoff) {
      location.href = API + '/sso/handoff?code=' + encodeURIComponent(res.handoff) + '&return=' + encodeURIComponent(next);
    } else {
      location.href = next;
    }
  }

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bbs-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

    $('[data-step="phone"]').addEventListener('submit', function (e) {
      e.preventDefault();
      var d = $('#bbs-login-phone').value.replace(/\D/g, '').replace(/^(?:91|0)(?=\d{10}$)/, '');
      if (!/^[6-9]\d{9}$/.test(d)) { msg('Enter your 10-digit WhatsApp number.'); return; }
      phoneDigits = d;
      sendCode(e.target);
    });

    $('[data-step="code"]').addEventListener('submit', function (e) {
      e.preventDefault();
      var code = $('#bbs-login-code').value.replace(/\D/g, '');
      if (code.length !== 6) { msg('Enter the 6-digit code.'); return; }
      var form = e.target;
      busy(form, true);
      var consentEl = document.getElementById('bbs-login-consent');
      var marketingConsent = consentEl ? !!consentEl.checked : false;
      request('/api/auth/verify', {
        method: 'POST',
        body: {
          phone: phoneDigits, countryCode: '91', code: code, client: 'shop',
          marketingConsent: marketingConsent,
          consentSource: 'shop:' + (location.pathname || '/'),
        },
      })
        .then(function (r) {
          if (!r.shopToken) throw new Error('Login service is out of date. Please try again later.');
          afterLogin(r);
        })
        .catch(function (err) { busy(form, false); msg(friendly(err)); $('#bbs-login-code').select(); });
    });

    $('#bbs-login-code').addEventListener('input', function (e) {
      e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
      if (e.target.value.length === 6) $('[data-step="code"]').requestSubmit();
    });
    $('[data-bbs-back]').addEventListener('click', function () { phoneDigits = ''; $('#bbs-login-code').value = ''; step('phone'); });
    $('[data-bbs-resend]').addEventListener('click', function () { sendCode($('[data-step="code"]')); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bbs-account]');
    if (t) { e.preventDefault(); goAccountOrLogin(t.getAttribute('data-bbs-next')); return; }
    var o = e.target.closest('[data-bbs-logout]');
    if (o) { e.preventDefault(); logout(); }
  });

  function logout() {
    clearLogin();
    ss(S_CHECKED, '1');                 // don't silently log straight back in
    var back = location.origin + '/';
    if (CFG.handoff) location.href = API + '/sso/logout?return=' + encodeURIComponent(back);
    else location.href = back;
  }

  // ── returning from beautifybysneha.com (#bbs_sso=…) ─────────────────────────
  function handleReturn() {
    var m = /(?:^#|&)bbs_sso=([^&]+)/.exec(location.hash);
    if (!m) return Promise.resolve();
    history.replaceState(null, '', location.pathname + location.search);
    ss(S_CHECKED, '1');
    var wantModal = ss(S_OPEN); ss(S_OPEN, null);
    var code = decodeURIComponent(m[1]);
    if (code === 'none') { if (wantModal) openModal(); return Promise.resolve(); }
    return request('/api/shop/sso/exchange', { method: 'POST', body: { code: code } })
      .then(function (r) {
        saveLogin(r.shopToken, r.user);
        paintHeader();
        var next = ss(S_NEXT); ss(S_NEXT, null);
        if (next) location.href = next;
        else if (wantModal) location.href = accountUrl();
      })
      .catch(function () { if (wantModal) openModal(); });
  }

  window.BBSAccount = {
    request: request, token: token, user: user, open: openModal, openInline: openModalInline,
    login: goAccountOrLogin, logout: logout, ready: null,
  };
  paintHeader();
  window.BBSAccount.ready = handleReturn().then(function () {
    document.dispatchEvent(new CustomEvent('bbs:account-ready'));
  });
})();
